import { PhysicianInfo } from 'types';

export const formatPhysicianName = ({
  credentials,
  firstName,
  lastName,
}: PhysicianInfo): string => {
  return `${firstName} ${lastName}${credentials ? `, ${credentials}` : ''}`;
};
